module.exports = "pegasus_template/assets/email1-column-14.png";